export default __webpack_public_path__ + "static/media/dentology.cbc32de6.png";